var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"mb-0"},[_vm._v("รายการสมัครสมาชิก")])]),[_c('pie-chart',{attrs:{"height":250,"chart-data":_vm.chartData,"extra-options":_vm.extraOptions}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }